import React, { useEffect, useState } from 'react'

import { useHistory, useParams } from 'react-router-dom'

import Contractor from '../../../../../presentation/pages/doctors/contractor'
import Loading from '../../../../../presentation/components/loading'

import { useResource } from '../../../../../presentation/hooks/resource'
import { useFetchResource } from '../../../../../presentation/hooks/fetch-resource'
import { useMap } from '../../../../../presentation/hooks/map'
import { useMe } from '../../../../../presentation/contexts/me'

import { makeContractors } from '../../../../usecases/contractors/remote-contractors-factory'
import {
  makeDoctorsContracts,
  makeContractorsContracts,
} from '../../../../usecases/contracts/remote-contracts-factory'

import IContractor from '../../../../../presentation/interfaces/contractor'

import { RoutesEnum, Authority } from '../../../../../presentation/enums'
import { getRoute } from '../../../../../presentation/helpers'

const MakeContractor = () => {
  document.title = 'Buscar Médicos - Contratante'

  const history = useHistory()

  const [contracts, setContracts] = useState<IContractor[]>([])

  const { id } = useParams<{ id: string }>()

  const { me } = useMe()

  const [, contractorService, contractor, loading] = useResource<IContractor>(
    makeContractors(),
  )

  const isContracted = contracts.some(
    (contract: any) => contract.contractorId === Number(id),
  )

  useFetchResource(contractorService.loadById, Number(id))

  useEffect(() => {
    const fetchContracts = async () => {
      if (me) {
        const res = await makeDoctorsContracts(me.id).load()
        setContracts(res)
      }
    }

    fetchContracts()
  }, [me])

  const { location } = useMap(contractor?.address)

  const handleOpenChat = () => {
    history.push(
      getRoute(RoutesEnum.CHAT, {
        interlocutorType: Authority.CONTRACTOR,
        interlocutorId: String(id),
      }),
    )
  }

  const handleContract = async () => {
    if (me?.id && id) {
      await makeContractorsContracts(Number(id)).post({
        doctor: me.id,
      })

      const res = await makeDoctorsContracts(me.id).load()
      setContracts(res)
    }
  }

  if (loading) {
    return <Loading />
  }

  if (!contractor) {
    return null
  }

  const props = {
    contractor: {
      ...contractor,
      imgUrl: contractor.document.find((doc: any) => doc.url.startsWith('images/'))?.url,
    },
    handleOpenChat,
    handleContract,
    location,
    isContracted,
  }

  return <Contractor {...props} />
}

export default MakeContractor
